import type { ReactNode, HTMLAttributes } from "react";

export interface TNeoIconProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  shadow?: boolean;
  isButton?: boolean;
}

const NeoIcon = ({
  children,
  shadow = true,
  isButton = true,
  ...props
}: TNeoIconProps) => {
  const shadowClass = shadow ? "" : "no-shadow";
  return (
    <div className={`neo-icon ${shadowClass}`} {...props}>
      {isButton ? (
        <button className={`icon__inn ${shadowClass}`} value="submit">
          {children}
        </button>
      ) : (
        <div role="button" className={`icon__inn ${shadowClass}`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default NeoIcon;
